import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=0250d0e6&scoped=true"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"
import style0 from "./GenericModal.vue?vue&type=style&index=0&id=0250d0e6&prod&lang=scss"
import style1 from "./GenericModal.vue?vue&type=style&index=1&id=0250d0e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0250d0e6",
  null
  
)

export default component.exports